"use client";

import { useEffect } from "react";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Bug kinh điển Next.js 15: deploy mới → tab cũ hit action ID cũ → 404.
    // Thay vì user thấy màn trắng → tự reload để lấy bundle mới.
    const isServerActionMismatch =
      error.message?.includes("Failed to find Server Action") ||
      error.message?.includes("Server Action") ||
      error.digest?.includes("NEXT_NOT_FOUND");

    if (isServerActionMismatch) {
      // Reload fresh, bypass cache
      window.location.reload();
    }
  }, [error]);

  return (
    <html>
      <body>
        <div style={{
          display: "flex", alignItems: "center", justifyContent: "center",
          minHeight: "100vh", padding: "2rem", fontFamily: "system-ui, sans-serif",
        }}>
          <div style={{ textAlign: "center", maxWidth: 400 }}>
            <h2 style={{ fontSize: 20, fontWeight: 800, marginBottom: 8 }}>
              Đang tải lại trang...
            </h2>
            <p style={{ fontSize: 13, color: "#64748b", marginBottom: 20 }}>
              Có cập nhật mới, chờ một chút nhé.
            </p>
            <button
              onClick={reset}
              style={{
                padding: "10px 24px", borderRadius: 999,
                background: "#0f3a4a", color: "white",
                fontSize: 13, fontWeight: 700, border: "none", cursor: "pointer",
              }}
            >
              Thử lại
            </button>
          </div>
        </div>
      </body>
    </html>
  );
}